import axios from 'axios';
import { loginreq, req } from './axiosFun';

// 登录接口
export const login = (params) => { return loginreq("post", "/login", params) };
// 获取用户菜单
export const menu = (params) => { return axios.get("/api/menu?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 退出接口
export const loginout = () => { return axios.delete("/api/login?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };



export const getDailyData = (params) => { return req("post", "/getData", params) };
/**
 * 用户管理
 **/
// 用户管理-获取用户列表
export const userList = (params) => { return req("post", "/userList/"+params.pageIndex+'/'+params.pageSize) };

export const getUserById = (params) => { return req("post", "/getUser", params) };

export const banUserById = (params) => { return req("post", "/ban", params) };

export const banUser3DaysById = (params) => { return req("post", "/ban3Days", params) };

export const banUser7DaysById = (params) => { return req("post", "/ban7Days", params) };

export const banUser30DaysById = (params) => { return req("post", "/ban30Days", params) };

export const untieUser = (params) => { return req("post", "/untie", params) };

export const getMsgIssue = (params) => {return req("post", "/sensitiveCheck/getSensitiveData", params)};

export const setIssueDone = (params) => {return req("post", "/sensitiveCheck/setIssueDone", params)};

// 获取用户聊天记录
export const getImgsBySenderId = (params) => { return req("post", "/getImgsBySenderId", params) };

// 发送警告通知
export const sendWarningInfoToUser = (params) => { return req("post", "/sendWarningInfoToUser", params) };




// 用户管理-保存（添加编辑）
export const userSave = (params) => { return req("post", "/api/User/save", params) };
// 用户管理-删除用户
export const userDelete = (params) => { return axios.delete("/api/User/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 用户管理-重置密码
export const userPwd = (params) => { return req("post", "/api/User/pwd", params) };
// 用户管理-修改状态
export const userLock = (params) => { return axios.get("/api/User/lock?userId=" + params.userId + "&lock=" + params.lock + "&token=" + localStorage.getItem('logintoken')) };
// 用户管理-用户下线
export const userExpireToken = (params) => { return req("get", "/api/User/expireToken/" + params, {}) };
// 用户管理-刷新缓存
export const userFlashCache = (params) => { return req("get", "/api/User/flashCache/" + params, {}) };


/**
 * 纸条管理
 */
// 纸条管理-获取纸条列表
export const paperList = (params) => { return req("post", "/paperList/"+params.pageIndex+'/'+params.pageSize) };

export const updateOpen = (params) => { return req("post", "/updateOpen",params) };

/**
 * 会员管理
 */
// 获取配置列表
export const vipConfigList = (params) => {return req("post", "/vipConfigList/"+params.pageIndex+'/'+params.pageSize)}
// 更新配置
export const updateVipConfig = (params) => {return req("post", "/editVipConfig", params)}
// 新增一个会员配置
export const addVipConfig = (params) =>{ return req("post", "/addVipConfig", params)}



// WEBPACK FOOTER //
// ./src/api/userMG.js